export default __webpack_public_path__ + "static/media/vf-default.dda81bbd.svg";